export const storeReducer=(state,action)=>{
    switch (action.type){
        case "TOGGEL_MOVIES":
            return {
                 ...state,
               showMovies:!state.showMovies
            };
         case "TOGGLE_TV":
            return {
                ...state,
                showTv:!state.showTv
            } 
        case "ADD_TO_STORE":
            return {
                ...state,
                stack:[...state.stack,{...action.payload,qty:1}]
            }
         case "REMOVE_FROM_STORE":
            return {
                ...state,
                stack:state.stack.filter((c)=>c.id!==action.payload.id),
            };   
         default: 
              return state;

    }
}

export const productReducer=(state,action)=>{
    switch (action.type){
        case "SORT_BY_RATING":
            return {...state,sort:action.payload};
        default:
            return state;    
    }
}
